import type {Rechnung} from '@dv/kitadmin/models';
import { RechnungsStatus} from '@dv/kitadmin/models';
import {DvbUtil, type Persisted} from '@dv/shared/code';

export function determineAvailableStateTransitions(rechnung: Persisted<Rechnung>): RechnungsStatus[] {
    // Stornieren soll immer sichtbar sein, auch wenn die Aktion nicht erlaubt ist:
    const storniert = [RechnungsStatus.EXTERNAL_STATUS.STORNIERT];
    const available = [...rechnung.stateTransitions, ...storniert];

    return DvbUtil.uniqueArray(available);
}
